// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoomDetail_wrapper__2vnT9","header":"RoomDetail_header__1IPYH"};